/**
 * @fileoverview Assemble the outer application's Redux state and shared document-query middleware. Domain reducers own draft/workspace context; `Documents/dataApi.js` owns metadata request snapshots and `Documents/reducer.js` owns persisted navigation. Store subscriptions persist eligible browser preferences without making them canonical server data or carrying file bytes across identities.
 */

import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { documentDataApi, documentDataSessionReducer, documentPermissionMiddleware, attachDocumentInvalidation } from './Documents/dataApi';
import calendarInputReducer from './CalendarInput/reducer'
import caseInfoReducer from './CaseDetails/reducer'
import appReducer from './App/reducer';
import documentsReducer, {
  loadDocumentsWorkspaceState,
  persistDocumentsWorkspaceState,
} from './Documents/reducer';



export function createAppStore(preloadedState = {}) {
  const store = configureStore({
    // Imperative cache channels rely on synchronous subscription delivery. React batches renders.
    enhancers: defaults => defaults({ autoBatch: false }),
    reducer: {
      calendarInput: calendarInputReducer,
      caseDetails: caseInfoReducer,
      app: appReducer,
      documents: documentsReducer,
      documentData: documentDataApi.reducer,
      documentDataSession: documentDataSessionReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(documentDataApi.middleware, documentPermissionMiddleware),
    preloadedState: {
      ...preloadedState,
      documents: preloadedState.documents || loadDocumentsWorkspaceState(),
    },
  });

  let persistedDocumentsState = store.getState().documents;
  persistDocumentsWorkspaceState(persistedDocumentsState);
  store.subscribe(

  () => {
    const nextDocumentsState = store.getState().documents;
    if (nextDocumentsState === persistedDocumentsState) return;
    persistedDocumentsState = nextDocumentsState;
    persistDocumentsWorkspaceState(nextDocumentsState);
  });

  return store;
}

const store = createAppStore();
setupListeners(store.dispatch);
attachDocumentInvalidation(store);

export default store
